if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    /* Variant media groups (VibeCore foundation, 2026-09-11): a media whose alt ends in " - <Colour>" belongs to
       that colour; when a variant's featured image is activated, only that colour's media stay visible, in the
       product editor's order. Media without a tag are always shown. */
    applyVariantFilter(color) {
      if (this.dataset.vcGroups !== 'true') return;
      const tagged = this.elements.viewer.querySelectorAll('[data-vc-color]:not([data-vc-color=""])');
      if (!color || tagged.length === 0) return;
      const show = (el) => el.classList.remove('vc-hidden');
      const hide = (el) => el.classList.add('vc-hidden');
      [this.elements.viewer, this.elements.thumbnails].forEach((root) => {
        if (!root) return;
        root.querySelectorAll('[data-vc-color]').forEach((el) => {
          const c = el.dataset.vcColor;
          (!c || c === color) ? show(el) : hide(el);
        });
        if (root.resetPages) root.resetPages();
      });
      // The zoom modal lists media by bare media id; map those ids to the gallery slides' colour tags.
      const sectionId = this.id.replace('MediaGallery-', '').replace('-duplicate', '');
      const colorById = {};
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
        colorById[el.dataset.mediaId.replace(`${sectionId}-`, '')] = el.dataset.vcColor || '';
      });
      const modal = document.querySelector(`#ProductModal-${sectionId} .product-media-modal__content`);
      if (modal) modal.querySelectorAll('[data-media-id]').forEach((el) => {
        const c = colorById[el.dataset.mediaId] || '';
        (!c || c === color) ? show(el) : hide(el);
      });
    }

    connectedCallback() {
      // Filtering is off by design (see setActiveMedia); applyVariantFilter stays available for a store that wants it.
      this.querySelectorAll('.vc-hidden').forEach((el) => el.classList.remove('vc-hidden'));
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      if (this.dataset.vcGroups === 'true') {
        // Ninos (2026-09-11): keep EVERY image visible in the product editor's order; a colour click only jumps
        // the gallery to that colour's first image. No hiding, no reordering.
        prepend = false;
      }
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
